<main role="main">
    <router-outlet></router-outlet>
</main>
<app-notifications></app-notifications>